import React, { useCallback, useEffect, useState } from 'react';
import SelectCustom from '../../../../../../../../components/SelectCustom';
import { useFormik } from 'formik';
import Loading from '../../../../../../../../core/common/Loading';
import { ToastContainer } from 'react-toastify';
import api from '../../../../../../../../services/api';
import formValidator from './validators/formValidator';
import { toast } from 'sonner';
import { useAuth } from '../../../../../../../../hooks/AuthenticateContext';

interface FormValues {
  id_operacao_porto_carrossel_transportadora: number;
  placa: string;
}

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  selectedRow?: any;
  id_operacao_porto_carrossel_transportadora?: number;
  onConfirm: () => void;
  onClose: () => void;
}

const Form: React.FC<Props> = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [,setPlates] = useState<any[]>([]);
  const [, setSearchQuery] = useState<string>("");
  const { user } = useAuth();

  const handleSubmit = useCallback(async (values: FormValues, row?: any) => {
    try {
      setLoading(true);

      const userId = user?.id;

      const rawBody = {
        id_operacao_porto_carrossel_transportadora: props.isEdit ? row?.id_operacao_porto_carrossel_transportadora : props.id_operacao_porto_carrossel_transportadora,
        id_operacao_porto_carrossel_transportadora_veiculo: props.isEdit ? row?.id_operacao_porto_carrossel_transportadora_veiculo : null,
        placa_dianteira: values.placa.replaceAll(".", "").replaceAll("-", "").replace("/", ""),
        id_usuario_historico: userId,
      }
      
      const body = Object.entries(rawBody).reduce((acc: any, [key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      }, {});

      if (props.isEdit) {
        const response = await api.post("/editar/operacaoPortoCarrosselTransportadoraVeiculos", body);

        if (response.status === 200) {
          toast.success("Veiculo salvo com sucesso!");
          props.onConfirm();
        } else {
          toast.error("Erro ao salvar o veiculo!");
        }
      } else {
        const response = await api.post("/cadastrar/operacaoPortoCarrosselTransportadoraVeiculos", body);

        if (response.status === 200) {
          toast.success("Veiculo salvo com sucesso!");
          props.onConfirm();
        } else {
          toast.error("Erro ao salvar o veiculo!");
        }
      }

      setLoading(false);
    } catch {
      toast.error("Erro ao salvar o veiculo!");
      setLoading(false);
    }
  }, [props.isEdit, props.id_operacao_porto_carrossel_transportadora]);

  const onLoadFormValues = useCallback((row?: any) => {
    const data = row;

    if (data) {
      formik.setFieldValue("placa", String(data.placa_dianteira));
      loadOptions(String(data.placa_dianteira), null);
    }
  }, []);

  const initialValues: FormValues = {
    placa: "",
    id_operacao_porto_carrossel_transportadora: props.selectedRow ? props.selectedRow.id_operacao_porto_carrossel_transportadora : 0,
  };

  const formik = useFormik({
    initialValues,
    validationSchema: formValidator,
    onSubmit: (values: FormValues) => {
      handleSubmit(values, props.selectedRow);
    },
  });

  const getPlates = useCallback(async (plate?: string) => {
    try {
      let body: any = {
        order_by: "data_historico",
        order_direction: "desc",
        qtd_por_pagina: 20
      }

      if(plate) {
        body = {
          ...body,
          placa: plate,
        }
      }

      const response = await api.post("/listar/veiculos", body);

      const mappingResponse = response.data.data.map((item: any) => {
        return {
          value: item.placa,
          label: item.placa,
        };
      });

      setPlates(mappingResponse);

      return mappingResponse;
    } catch (error) {
      console.error("Failed to fetch plates:", error);
    }
  }, []);

   const loadOptions = async (inputValue: string, callback: any) => {
    if (inputValue.length < 3) {
      callback([]);
      return;
    }

    return await getPlates(inputValue);
  };

  useEffect(() => {
    getPlates();
  }, [getPlates]);

  useEffect(() => {
    if (props.isView || props.isEdit) {
      onLoadFormValues(props.selectedRow);
    }
  }, [props.isEdit, props.isView, props.selectedRow, onLoadFormValues]);

  return (
    <>
      <Loading loading={loading} skeletonFields={1} skeletonColumns={1} />

      <ToastContainer />
      <div className="w-full p-5">
        <div className="grid grid-cols-1 gap-3 mb-2">
          <div>
            <SelectCustom
              async
              data={loadOptions}
              onChange={(selectedOption: any) => {
                formik.setFieldValue("placa", String(selectedOption.value));
              }}
              onInputChange={(inputValue: string) => {
                setSearchQuery(inputValue);
              }}
              title="Placa"
              touched={formik.touched.placa}
              error={formik.errors.placa}
              disabled={props.isView}
              value={formik.values.placa}
            />
          </div>
        </div>
      </div>
      <div className="w-full h-14 flex items-center justify-end bg-[#FFFFFF] shadow-xl">
        <button
          type="button"
          className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#F9FAFA] text-sm text-[#000000] font-bold rounded-full mr-2"
          style={{ border: "1px solid #DBDEDF" }}
          onClick={props.onClose}
        >
          Cancelar
        </button>
        {!props.isView && (
          <button
            type="button"
            className="w-24 h-9 pl-3 pr-3 flex items-center justify-center bg-[#0A4984] text-sm text-[#fff] font-bold rounded-full mr-2"
            onClick={() => formik.handleSubmit()}
          >
            Salvar
          </button>
        )}
      </div>
    </>
  )
}

export default Form;
